import inventoryAPI from '@/services/api/inventory'

const index = {
	namespaced: true,
	state: () => ({
		historyList: [],
		deleteHistoryList: [],
		count: null,
	}),
	getters: {},
	mutations: {
		setHistoryList: (state, payload) => {
			state.historyList = payload.list
			state.count = payload.count
		},
		setDeleteHistoryList: (state, payload) => {
			state.deleteHistoryList = payload.list
		},
		addHistoryList: (state, payload) => {
			state.historyList = [...state.historyList, ...payload.list]
			state.count = payload.count
		},
		addDeleteHistoryList: (state, payload) => {
			state.deleteHistoryList = [
				...state.deleteHistoryList,
				...payload.list,
			]
		},
	},
	actions: {
		loadInventoryHistory: async ({ commit }, payload) => {
			const { instId, paramsObject } = payload
			const response = await inventoryAPI.lookupInventoryHistory(
				instId,
				paramsObject
			)
			commit('setHistoryList', response.data)
		},
		addInventoryHistory: async ({ commit }, payload) => {
			const { instId, paramsObject } = payload
			const response = await inventoryAPI.lookupInventoryHistory(
				instId,
				paramsObject
			)
			commit('addHistoryList', response.data)
		},
		loadInventoryDeleteHistory: async ({ commit }, payload) => {
			const { instId, paramsObject } = payload
			const response = await inventoryAPI.lookupInventoryHistory(
				instId,
				paramsObject
			)
			commit('setDeleteHistoryList', response.data)
		},
		addInventoryDeleteHistory: async ({ commit }, payload) => {
			const { instId, paramsObject } = payload
			const response = await inventoryAPI.lookupInventoryHistory(
				instId,
				paramsObject
			)
			commit('addDeleteHistoryList', response.data)
		},
	},
}
export default index
